<template>
    <div class="p-3">
    	<div v-if="formOpen" class="row mb-2">
            <div class="col">
                <note-form />
            </div>
        </div>
        <div v-else>
             <div class="row mb-2">
                <div class="col">
                    <button class="btn btn-sm btn-primary" @click="openForm">Add Note</button>
                </div>
            </div>
            <div class="row row-cols-1">
                <note-card
                    v-for="note in notes" 
                    :key="note.id"
                    :note="note" 
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import NoteCard from './NoteCard'
import NoteForm from './NoteForm'

export default {
    name: "NoteList",
    components: {
        NoteCard,
        NoteForm
    },
    props: { 
        participant: Object,
    },
    data() {
        return {
            addingNote: false
        }       
    },
    methods: {
    	openForm() {
            this.$store.dispatch('notes/setFormOpen', true)
        },
    },
    computed: {
        ...mapState({
            notes: state => state.notes.notes,
            formOpen: state => state.notes.formOpen
        })
    },
    mounted () {
    	this.$store.dispatch('notes/setParticipant', this.participant)
        this.$store.dispatch('notes/fetchNotes', {'participant_id': this.participant.id})
        this.$store.dispatch('notes/fetchUsers')
    }
}

</script>